import React from 'react';
import { useAvatar } from '../../../hooks/useAvatar';
import getName from '../../../utils/getName';
import getDateString from '../../../utils/getDateString';
import _truncate from 'lodash/truncate';
import Stack, { contentStackSpacing } from '../../v2BaseComponents/Stack';
import { getSpacing } from '../../../utils/spacing';
import Avatar, { getFallbackFromName } from '../../v2BaseComponents/Avatar';
import Text from '../../v2BaseComponents/Text';
import { View } from 'react-native';

export type NoteCommentOwnProps = {
    avatarAPIUrl: string | null;
    comment: string;
    firstName: string | null;
    lastName: string | null;
    preferredName: string | null | undefined;
    createdAt: string | null;
};

export type NoteCommentProps = NoteCommentOwnProps;

const avatarContentWidth = 33;

const NoteComment: React.FC<NoteCommentProps> = ({
    comment,
    firstName,
    lastName,
    preferredName,
    avatarAPIUrl,
    createdAt,
}) => {
    const { avatar, isLoadingAvatar } = useAvatar({
        avatarAPIUrl: avatarAPIUrl,
    });

    const hasName = firstName || preferredName || lastName;

    return (
        <Stack vertical align="flex-start" space={contentStackSpacing} testID="comment-display" fullWidth>
            <Stack horizontal align="center" space={getSpacing(2)} fullWidth>
                <Avatar
                    image={avatar?.base64 || null}
                    size={'sm'}
                    isLoading={isLoadingAvatar}
                    fallbackName={hasName ? getFallbackFromName(preferredName || firstName, lastName) : ''}
                />
                <Stack
                    vertical
                    space={0}
                    style={{
                        paddingTop: getSpacing(0.25),
                    }}
                    flex={1}
                >
                    <Text variant="body-1">
                        {hasName
                            ? getName({
                                  firstName,
                                  preferredName,
                                  lastName,
                              })
                            : null}
                    </Text>
                    <Text variant="body-2">{getDateString(createdAt, 'date-time')}</Text>
                </Stack>
            </Stack>
            <Stack horizontal fullWidth justify="flex-start" space={getSpacing(2)}>
                <View style={{ width: avatarContentWidth }} />
                <View style={{ flex: 1 }}>
                    <Text variant={'body-1'}>{comment}</Text>
                </View>
            </Stack>
        </Stack>
    );
};

export default React.memo(NoteComment);
